export const generateButtonToggle = (
  buttonClassName,
  topContentsClassName,
  bottomContentsClassName
) => () => {
  const floatingButton = document.querySelector(buttonClassName);
  if (!floatingButton) return;
  const scrollY = window.pageYOffset;

  const pageHight = document.body.clientHeight; // ページ全体の高さ
  const buttonHight = floatingButton.clientHeight; // ボタンの高さ
  // ページ最上部からtop-contentsまでの距離
  const topContent = document.querySelector(topContentsClassName);
  if (!topContent) return;
  const topToTopContentDist = topContent.getBoundingClientRect().top + scrollY;
  // ページ最上部からbottom-contentsまでの距離
  const bottomContent = document.querySelector(bottomContentsClassName);
  if (!bottomContent) return;
  const topToBottomContentDist = pageHight - bottomContent.clientHeight;

  const scrollRange =
    topToBottomContentDist - topToTopContentDist - buttonHight * 3;

  if (scrollY > topToTopContentDist && scrollY < scrollRange) {
    floatingButton.classList.add('is-floating');
  } else {
    floatingButton.classList.remove('is-floating');
  }
};
